import Axios from "axios";

import { authModel } from "src/store/authModel";
import { userModel } from "src/store/userModel";

// eslint-disable-next-line import/no-cycle
import { logout } from "./logout";


const api = Axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
})

api.interceptors.request.use((config) => {
  const token = authModel.getState().accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
})

api.interceptors.response.use((response) => response, (error) => {
  if (error?.response?.status === 401) {
    const userId = userModel.getState().id;
    if (userId) {
      logout(userId);
    }
  }
  return Promise.reject(error);
});

export default api;
